export * from "./enums";

export const SETS_SHOW_ON_STATUSES = [
  {
    label: "Enabled",
    value: true,
    backgroundColor: "#16C350"
  },
  {
    label: "Disabled",
    value: false,
    backgroundColor: "#A8A8BB"
  }
];
